import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the view for table of partner products.
 * @extends JetView
 */
export default class tablePartnersProductsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (devConfig.getPermAction('partnersProvidersEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 50, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Provider', // Column ID
                                    header: _('Proveedor'), // Localized column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Partner', // Column ID
                                    header: _('Partner'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsVerified', // Column ID
                                    header: _('Verificado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'FilterCountry', // Column ID
                                    header: _('Filtro País'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Maximum', // Column ID
                                    header: _('Máximo'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Minimum', // Column ID
                                    header: _('Mínimo'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Detail', // Column ID
                                    header: _('Detalle'), // Localized column header
                                    width: 180, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    // Edit action
                                    $$('editwinPartnerProducts').show(); // Show edit window
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            // Data source URL
                            url: devConfig.geturlApi() + 'PartnersProviders/GetPartnersProviders',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'PartnersProviders/GetPartnersProviders'; // API URL for fetching partner providers
        var cthis = this; // Reference to the current context
        var providers = []; // Array to hold provider data
        var popup = webix.ui({
            // Popup window for editing partner products
            view: 'window',
            id: 'editwinPartnerProducts', // ID for the edit window
            width: screen.width < 500 ? 350 : 450, // Width based on screen size
            height: screen.width < 500 ? 740 : 590, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                // Header configuration
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar Partner') }, // Label for editing partner
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            // Close action
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center the popup
            modal: false, // Non-modal window
            body: {
                // Body configuration
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form view for editing
                    id: 'editform', // ID for the edit form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    height: screen.width < 500 ? 740 : 540, // Height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'text', // Text input for ID
                            label: 'Id', // Label for the input
                            name: 'Id', // Name attribute
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Provider
                            label: _('Proveedor'), // Localized label
                            name: 'Provider', // Name attribute
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Partner
                            label: _('Partner'), // Localized label
                            name: 'Partner', // Name attribute
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for IsActivate
                            label: _('Estado'), // Localized label
                            name: 'IsActivate', // Name attribute
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for IsVerified
                            label: _('Verificado'), // Localized label
                            name: 'IsVerified', // Name attribute
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for FilterCountry
                            label: _('Filtro País'), // Localized label
                            name: 'FilterCountry', // Name attribute
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Maximum
                            label: _('Máximo'), // Localized label
                            name: 'Maximum', // Name attribute
                            attributes: { type: 'number' }, // Input type
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Minimum
                            label: _('Mínimo'), // Localized label
                            name: 'Minimum', // Name attribute
                            attributes: { type: 'number' }, // Input type
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Detail
                            label: _('Detalle'), // Localized label
                            name: 'Detail', // Name attribute
                            labelWidth: 160, // Label width
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            margin: 10, // Margin for the next element
                            cols: [
                                {
                                    view: 'text', // Text input for Note
                                    labelPosition: 'top', // Label position
                                    label: _('Explicación'), // Localized label
                                    name: 'Note', // Name attribute
                                    labelWidth: 160, // Label width
                                    attributes: { type: 'text' }, // Input type
                                },
                            ],
                        },
                        {
                            cols: [
                                // Button row
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'), // Button label
                                    click: function () {
                                        // Cancel action
                                        this.getTopParentView().hide(); // Hide the popup
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form', // Button type
                                    value: _('Guardar'), // Button label
                                    click: function ($e) {
                                        // Save action
                                        var values = $$('editform').getValues(); // Get form values
                                        var c2this = this; // Reference to the current context
                                        webix
                                            .ajax() // AJAX request to save data
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnerProduct/UpdatePartnerProvider', // API endpoint
                                                values, // Data to send
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message(
                                                                'Error: ' + text.AlertMessage, // Display error message
                                                            );
                                                        } else {
                                                            $$('editform').clear(); // Clear form
                                                            c2this.getTopParentView().hide(); // Hide the popup
                                                            webix.message(
                                                                'Proveedor Partner Editado', // Success message
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var popupAdd = webix.ui({
            // Popup window for adding partner products
            view: 'window',
            id: 'AddPartnerProducts', // ID for the add window
            width: screen.width < 500 ? 350 : 450, // Width based on screen size
            height: screen.width < 500 ? 650 : 550, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                // Header configuration
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Añadir Proveedor Partner') }, // Label for adding partner
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            // Close action
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center the popup
            modal: true, // Modal window
            body: {
                // Body configuration
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form view for adding
                    id: 'addform', // ID for the add form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    height: screen.width < 500 ? 650 : 500, // Height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'combo', // Combo box for Provider
                            label: _('Proveedores'), // Localized label
                            name: 'Provider', // Name attribute
                            id: 'AddProvider', // ID for the provider combo
                            options: providers, // Options for the combo
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for Partner
                            label: _('Partner'), // Localized label
                            name: 'Partner', // Name attribute
                            options: profile.Partners, // Options for the combo
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for IsActivate
                            label: _('Estado'), // Localized label
                            name: 'IsActivate', // Name attribute
                            value: 'A', // Default value
                            options: [
                                // Options for the combo
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for IsVerified
                            label: _('Verificado'), // Localized label
                            name: 'IsVerified', // Name attribute
                            value: 'I', // Default value
                            options: [
                                // Options for the combo
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for FilterCountry
                            label: _('Filtro País'), // Localized label
                            name: 'FilterCountry', // Name attribute
                            value: 'I', // Default value
                            options: [
                                // Options for the combo
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Maximum
                            label: _('Máximo'), // Localized label
                            name: 'Maximum', // Name attribute
                            value: 0, // Default value
                            attributes: { type: 'number' }, // Input type
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Minimum
                            label: _('Mínimo'), // Localized label
                            name: 'Minimum', // Name attribute
                            value: 0, // Default value
                            attributes: { type: 'number' }, // Input type
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Detail
                            label: _('Detalles'), // Localized label
                            name: 'Detail', // Name attribute
                            value: '{}', // Default value
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            cols: [
                                // Button row
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'), // Button label
                                    click: function () {
                                        // Cancel action
                                        this.getTopParentView().hide(); // Hide the popup
                                        $$('addform').clear(); // Clear the form
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form', // Button type
                                    value: _('Guardar'), // Button label
                                    click: function ($e) {
                                        // Save action
                                        var values = $$('addform').getValues(); // Get form values
                                        var c2this = this; // Reference to the current context
                                        webix
                                            .ajax() // AJAX request to save data
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnerProduct/CreatePartnerProvider', // API endpoint
                                                values, // Data to send
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message(
                                                                'Error: ' + text.AlertMessage, // Display error message
                                                            );
                                                        } else {
                                                            $$('addform').clear(); // Clear form
                                                            c2this.getTopParentView().hide(); // Hide the popup
                                                            webix.message(
                                                                'Proveedor Partner Agregado', // Success message
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        this.on(this.app, 'addProductPartner:button', (filter) => {
            // Event handler for adding partner products
            popupAdd.show(); // Show add popup
            var optionsCountries = $$('AddProvider').getList(); // Get provider options
            optionsCountries.clearAll(); // Clear existing options
            optionsCountries.parse(providers); // Parse new options
        });
        var filter = ''; // Filter string
        this.on(this.app, 'partnerProducts:filter', (filterData) => {
            // Event handler for filtering partner products
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter string
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event handler for player selection
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Event handler for double click
            var item = this.getItem(id); // Get clicked item
            popup.show(); // Show edit popup
        });
        $$('editform').bind($$('datatable')); // Bind edit form to datatable
        webix
            .ajax() // AJAX request to fetch product providers
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Providers/GetProductProviders', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize ID field
                            .replace(/"Name"/g, '"value"'), // Normalize Name field
                    );
                    console.log(data); // Log fetched data
                    providers = data.Data; // Store provider data
                },
            });
    }
}

// FILE DOCUMENTED
